import cx from "classnames";
import LinkIcon from "../../assets/icon/link.svg";
import HomeIcon from "../../assets/icon/home.svg";
import SearchIcon from "../../assets/icon/search.svg";
import HomeSearchIcon from "../../assets/icon/home-search.svg";
import StepBackIcon from "../../assets/icon/step-back.svg";
import Like from "../../assets/icon/like.svg";
import LikeActive from "../../assets/icon/like-active.svg";
import Collect from "../../assets/icon/collect.svg";
import CollectActive from "../../assets/icon/collect-active-icon.svg";
import ShareIcon from "../../assets/icon/share.svg";
import WxIcon from "../../assets/icon/wx.svg";
import TimelineIcon from "../../assets/icon/timeline.svg";
import QQIcon from "../../assets/icon/qq.svg";
import WeiboIcon from "../../assets/icon/weibo.svg";
import EmptyThreadIcon from "../../assets/icon/empty-thread.svg";
import CommentIcon from "../../assets/icon/comment.svg";
import ExtendIcon from "../../assets/icon/extend.svg";
import ArrowExtendIcon from "../../assets/icon/arrow-expand.svg";
import CloseIcon from "../../assets/icon/close.svg";
import TipsArrowIcon from "../../assets/icon/tips-arrow.svg";
import MoreArrowIcon from "../../assets/icon/more-arrow.svg";
import HomeMoreArrowIcon from "../../assets/icon/home-more-arrow.svg";
import FullScreenIcon from "../../assets/icon/full-screen.svg";
import CameraIcon from "../../assets/icon/camera.svg";
import CameraDisable from "../../assets/icon/camera-disable.svg";
import EmptyDeviceIcon from "../../assets/icon/account/no-sb.svg";
import MyDevice from "../../assets/icon/account/my-sb.svg";
import MyDeviceMore from "../../assets/icon/account/my-sb-more.svg";
import MySbModalClose from "../../assets/icon/account/my-sb-modal-close.svg";
import MyInfoClose from "../../assets/icon/account/my-info-close.svg";
import PhotoIcon from "../../assets/icon/photo.svg";
import PhotoDisable from "../../assets/icon/photo-disable.svg";
import EmojiIcon from "../../assets/icon/emoji.svg";
import KeykoardIcon from "../../assets/icon/keyboard.svg";
import WhiteClose from "../../assets/icon/white-close.svg";
import MClose from "../../assets/icon/m-close.svg";
import LoadingIcon from "../../assets/icon/loading.svg";
import LoadingWhiteIcon from "../../assets/icon/loading-white.svg";
import Skeleton from "../../assets/icon/skeleton.svg";
import ScancodeIcon from "../../assets/icon/scan-code.svg";
import CopyLinkIcon from "../../assets/icon/copy-link.svg";
import CommentErrorIcon from "../../assets/icon/comment-error.svg";
import EmptyComment from "../../assets/icon/empty-comment.svg";
import Reply from "../../assets/icon/reply.svg";
import ArrowLeft from "../../assets/icon/arrow-left.svg";
import ArrowRight from "../../assets/icon/arrow-right.svg";
import CommentSkeleton from "../../assets/icon/comment-skeleton.svg";
import NaveBackIcon from "../../assets/icon/nav.back.svg";
import NaveUserIcon from "../../assets/icon/nav.user.svg";
import AdminIcon from "../../assets/icon/admin.svg";
import VipIcon from "../../assets/icon/vip.svg";
import PageViewIcon from "../../assets/icon/page-view.svg";
import AllDevicesIcon from "../../assets/icon/all-devices.svg";
import NavBackHomeIcon from "../../assets/icon/nav-back-home.svg";
import NavDevicesBackIcon from "../../assets/icon/nav-devices-back.svg";
import HotIcon from "../../assets/icon/hot-colorful.svg";
import HotWhiteIcon from "../../assets/icon/hot-white.svg";
import StoreIcon from "../../assets/icon/store.svg";
import PinnedIcon from "../../assets/icon/pinned.svg";
import MenuIcon from "../../assets/icon/menu.svg";
import Praise from "../../assets/icon/praise.svg";
import PraiseActive from "../../assets/icon/praise-active.svg";
import FavoriteIcon from "../../assets/icon/favorite.svg";
import FavoriteActiveIcon from "../../assets/icon/favorite-active.svg";
import RankFirst from "../../assets/icon/rank-1.svg";
import RankSecond from "../../assets/icon/rank-2.svg";
import RankThird from "../../assets/icon/rank-3.svg";
import RankFour from "../../assets/icon/rank-4.svg";
import RankFive from "../../assets/icon/rank-5.svg";
import VerticalExtend from "../../assets/icon/vertical-extend.svg";
import ActivityTag from "../../assets/icon/activity-tag.svg";
import DeviceSeriesTag from "../../assets/icon/device-series-tag.svg";
import TestToolsIcon from "../../assets/icon/test-tools.svg";
import Styles from "./index.module.scss";
import { ChannelTagDisplayTypeEnum } from "@/api/detail";
import LikeInFooter from "../../assets/icon/like-footer.svg";
import LikeInFooterActive from "../../assets/icon/like-footer-active.svg";
import CollectInFooter from "../../assets/icon/collect-footer.svg";
import CollectInFooterActive from "../../assets/icon/collect-active.svg";
import ReplyInFooter from "../../assets/icon/reply-footer.svg";
import ShareInFooter from "../../assets/icon/share-footer.svg";
import CameraFill from "../../assets/icon/camera-fill.svg";
import CheckedIcon from "../../assets/icon/checked.svg";
import StarIcon from "../../assets/icon/star.svg";
import ProfileSleleton from "../../assets/icon/profile-skeleton.svg";
import HeaderSearch from "../../assets/icon/header/search.svg";
import HeaderClose from "../../assets/icon/header/close.svg";
import Empty from "../../assets/icon/empty.svg";
import SearchArrowLeft from "../../assets/icon/search/search-arrow-left.svg";
import SearchCloseCircle from "../../assets/icon/search/search-close-circle.svg";
import SearchInputIcon from "../../assets/icon/search/search-input-icon.svg";
import AccountArrowLeft from "../../assets/icon/account/ArrowLeft.svg";
import AccountArrowRight from "../../assets/icon/account/ArrowRight.svg";
import AccountBadge from "../../assets/icon/account/Badge.svg";
import AccountCheckInButton from "../../assets/icon/account/CheckInButton.svg";
import AccountDraftStatusIndicator from "../../assets/icon/account/DraftStatusIndicator.svg";
import AccountEdit from "../../assets/icon/account/Edit.svg";
import AccountLikeCountIndicator from "../../assets/icon/account/LikeCountIndicator.svg";
import AccountMessageCenterPanel from "../../assets/icon/account/MessageCenterPanel.svg";
import AccountMoreOptionsMenu from "../../assets/icon/account/MoreOptionsMenu.svg";
import AccountPlay from "../../assets/icon/account/Play.svg";
import AccountSend from "../../assets/icon/account/Send.svg";
import AccountUnLikeCountIndicator from "../../assets/icon/account/UnLikeCountIndicator.svg";
import AccountVerifyBadge from "../../assets/icon/account/VerifyBadge.svg";
import AccountViewCountDisplay from "../../assets/icon/account/ViewCountDisplay1.svg";
import GoToDetailIcon from "../../assets/icon/account/go_to_detail.svg";
import FileImageFill from "../../assets/icon/account/file-image-fill.svg";
export interface ICommonIcon {
  className?: string;
  icon: string;
  onClick?: () => void;
}

const CommonIcon = ({
  className = "",
  icon,
  onClick = () => {},
}: ICommonIcon) => {
  const handleClick = () => {
    onClick();
  };

  const renderIcon = () => {
    switch (icon) {
      case "test-tools":
        return <TestToolsIcon />;
      case "pinned":
        return <PinnedIcon />;
      case "menu":
        return <MenuIcon />;
      case "store":
        return <StoreIcon />;
      case "hot":
        return <HotIcon />;
      case "hot-white":
        return <HotWhiteIcon />;
      case "nav-devices-back":
        return <NavDevicesBackIcon />;
      case "nav-back-home":
        return <NavBackHomeIcon />;
      case "all-devices":
        return <AllDevicesIcon />;
      case "link":
        return <LinkIcon />;
      case "home":
        return <HomeIcon />;
      case "search":
        return <SearchIcon />;
      case "home-search":
        return <HomeSearchIcon />;
      case "step-back":
        return <StepBackIcon />;
      case "like":
        return <Like />;
      case "like-active":
        return <LikeActive />;
      case "collect":
        return <Collect />;
      case "collect-active":
        return <CollectActive />;
      case "share":
        return <ShareIcon />;
      case "wx":
        return <WxIcon />;
      case "timeline":
        return <TimelineIcon />;
      case "qq":
        return <QQIcon />;
      case "weibo":
        return <WeiboIcon />;
      case "empty-thread":
        return <EmptyThreadIcon />;
      case "comment":
        return <CommentIcon />;
      case "extend":
        return <ExtendIcon />;
      case "arrow-extend":
        return <ArrowExtendIcon />;
      case "close":
        return <CloseIcon />;
      case "tips-arrow":
        return <TipsArrowIcon />;
      case "more-arrow":
        return <MoreArrowIcon />;
      case "home-more-arrow":
        return <HomeMoreArrowIcon />;
      case "full-screen":
        return <FullScreenIcon />;
      case "camera":
        return <CameraIcon />;
      case "camera-disable":
        return <CameraDisable />;
      case "empty-device":
        return <EmptyDeviceIcon />;
      case "my-device":
        return <MyDevice />;
      case "my-device-more":
        return <MyDeviceMore />;
      case "my-sb-modal-close":
        return <MySbModalClose />;
      case "my-info-close":
        return <MyInfoClose />;
      case "photo-disable":
        return <PhotoDisable />;
      case "photo":
        return <PhotoIcon />;
      case "emoji":
        return <EmojiIcon />;
      case "keyboard":
        return <KeykoardIcon />;
      case "white-close":
        return <WhiteClose />;
      case "m-close":
        return <MClose />;
      case "loading":
        return <LoadingIcon />;
      case "loading-white":
        return <LoadingWhiteIcon />;
      case "skeleton":
        return <Skeleton />;
      case "scan-code":
        return <ScancodeIcon />;
      case "copy-link":
        return <CopyLinkIcon />;
      case "comment-error":
        return <CommentErrorIcon />;
      case "empty-comment":
        return <EmptyComment />;
      case "reply":
        return <Reply />;
      case "arrow-left":
        return <ArrowLeft />;
      case "arrow-right":
        return <ArrowRight />;
      case "comment-skeleton":
        return <CommentSkeleton />;
      case "nav-back":
        return <NaveBackIcon />;
      case "nav-user":
        return <NaveUserIcon />;
      case "admin-title":
        return <AdminIcon />;
      case "vip-title":
        return <VipIcon />;
      case "page-view":
        return <PageViewIcon />;
      case "praise":
        return <Praise />;
      case "praise-active":
        return <PraiseActive />;
      case "favorite":
        return <FavoriteIcon />;
      case "favorite-active":
        return <FavoriteActiveIcon />;
      case "rank-1":
        return <RankFirst />;
      case "rank-2":
        return <RankSecond />;
      case "rank-3":
        return <RankThird />;
      case "rank-4":
        return <RankFour />;
      case "rank-5":
        return <RankFive />;
      case "vertical-extend":
        return <VerticalExtend />;
      case ChannelTagDisplayTypeEnum.ACTIVITY:
        return <ActivityTag />;
      case ChannelTagDisplayTypeEnum.GROUP:
        return <DeviceSeriesTag />;
      case "like-in-footer":
        return <LikeInFooter />;
      case "like-in-footer-active":
        return <LikeInFooterActive />;
      case "collect-in-footer":
        return <CollectInFooter />;
      case "collect-in-footer-active":
        return <CollectInFooterActive />;
      case "reply-in-footer":
        return <ReplyInFooter />;
      case "share-in-footer":
        return <ShareInFooter />;
      case "camera-fill":
        return <CameraFill />;
      case "checked":
        return <CheckedIcon />;
      case "star":
        return <StarIcon />;
      case "profile-sleleton":
        return <ProfileSleleton />;
      case "header-search":
        return <HeaderSearch />;
      case "header-close":
        return <HeaderClose />;
      case "empty-image":
        return <Empty />;
      case "file-image-fill":
        return <FileImageFill />;
      // 搜索左箭头icon
      case "search-arrow-left":
        return <SearchArrowLeft />;
      // 搜索关闭icon
      case "search-close-circle":
        return <SearchCloseCircle />;
      // 搜索输入框图标icon
      case "search-input-icon":
        return <SearchInputIcon />;
      // account 相关图标
      case "account-arrow-left":
        return <AccountArrowLeft />;
      case "account-arrow-right":
        return <AccountArrowRight />;
      case "account-badge":
        return <AccountBadge />;
      case "account-check-in-button":
        return <AccountCheckInButton />;
      case "account-draft-status-indicator":
        return <AccountDraftStatusIndicator />;
      case "account-edit":
        return <AccountEdit />;
      case "account-like-count-indicator":
        return <AccountLikeCountIndicator />;
      case "account-message-center-panel":
        return <AccountMessageCenterPanel />;
      case "account-more-options-menu":
        return <AccountMoreOptionsMenu />;
      case "account-play":
        return <AccountPlay />;
      case "account-send":
        return <AccountSend />;
      case "account-unlike-count-indicator":
        return <AccountUnLikeCountIndicator />;
      case "account-verify-badge":
        return <AccountVerifyBadge />;
      case "account-view-count-display":
        return <AccountViewCountDisplay />;
      case "go-to-detail":
        return <GoToDetailIcon />;
      default:
        return null;
    }
  };

  return (
    <div className={cx(Styles.root, className)} onClick={handleClick}>
      {renderIcon()}
    </div>
  );
};

export default CommonIcon;
